import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import DotsVerticalIco from "../../../../../assets/icons/DotsVerticalIco";
import { HandleSkeletion } from "../../../../../utils/constants";
import {
  StyledFlexRowView,
  StyledTableBodyTableCell,
  StyledTableTitleTableCell,
  StyledTypo,
  TableContainerBorder,
} from "../../../../common-components/StyledComponents";

function Interactions({
  SummaryJobData,
  interactionHeaderData,
  tableLoader,
  handleInteractionAction,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const interactionsData = [
    {
      id: "01",
      type: "Title",
      action: "Title",
      created_at: "Oct 10, 2024",
      created_by: "Olivia Rhye",
      updated_fields: "",
    },
    {
      id: "02",
      type: "Title",
      action: "Title",
      status: "",
      created_at: "Oct 10, 2024",
      created_by: "Olivia Rhye",
      updated_fields: "",
    },
  ];
  // const interactionsData = SummaryJobData?.interactions || [];
  // console.log(interactionsData, "interactionsDatainteractionsData");
  return (
    <TableContainerBorder sx={{ marginTop: "0px !important" }}>
      <Table>
        <TableHead>
          <TableRow>
            {interactionHeaderData?.map((item) => {
              return (
                <StyledTableTitleTableCell>{item}</StyledTableTitleTableCell>
              );
            })}
          </TableRow>
        </TableHead>
        {tableLoader ? (
          <>
            {Array.from({ length: 3 }).map((_, index) => (
              <TableRow>
                {Array.from({ length: interactionHeaderData?.length }).map(
                  (_, index) => (
                    <TableCell key={index}>
                      <HandleSkeletion height={30} />
                    </TableCell>
                  )
                )}
              </TableRow>
            ))}
          </>
        ) : (
          <TableBody>
            {interactionsData?.map((interactions) => (
              <TableRow key={interactions.id}>
                <StyledTableBodyTableCell>
                  {interactions.id}
                </StyledTableBodyTableCell>
                <StyledTableBodyTableCell>
                  {interactions.type}
                </StyledTableBodyTableCell>
                <StyledTableBodyTableCell>
                  {interactions.action}
                </StyledTableBodyTableCell>

                <StyledTableBodyTableCell>
                  {interactions.created_at}
                </StyledTableBodyTableCell>
                <TableCell>
                  <StyledFlexRowView>
                    <StyledTypo> {interactions.created_by}</StyledTypo>
                  </StyledFlexRowView>
                </TableCell>
                <TableCell>
                  {interactions.length !== 0 && (
                    <IconButton
                      onClick={() => {
                        handleInteractionAction(interactions);
                      }}
                      disabled
                      style={{ opacity: "0.4" }}
                    >
                      <DotsVerticalIco />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        )}
      </Table>
    </TableContainerBorder>
  );
}

export default Interactions;
